import styled, { css } from 'styled-components';

interface WrapperProps {
    $canShow?: boolean;
}

export const ImageToggleWrapper = styled.div<WrapperProps>`
    position: absolute;
    left: 0;
    bottom: calc(100% + 10px);
    display: flex;
    align-items: center;
    padding: 0 8px 0 12px;
    height: 32px;
    border-radius: 40px;
    background: ${({ theme }) => theme.shades.white[10]};
    cursor: pointer;
    opacity: 0;
    transition: opacity ${({ theme }) => theme.transitions.speeds.normal}s;

    /* Fix image toggle sometimes not being triggered */
    > * {
        pointer-events: none;
    }

    &:focus {
        opacity: 1;
    }

    ${({ $canShow }) =>
        !$canShow &&
        css`
            /* If can't show prevent hover / focus from showing element */
            opacity: 0 !important;
            pointer-events: none;
        `}
`;

export const ToggleWrapper = styled.div`
    margin-left: 10px;
    height: 18px;
    width: 32px;
    border-radius: 40px;
    background: ${({ theme }) => theme.shades.white[10]};
`;

interface IconWrapperProps {
    $showingImage: boolean;
}

export const IconWrapper = styled.div.attrs<IconWrapperProps>(({ $showingImage, theme }) => ({
    style: {
        transform: $showingImage && 'translateX(14px)',
        background: $showingImage && theme.colors.purple,
    },
}))<IconWrapperProps>`
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    width: 18px;
    height: 18px;
    background: ${({ theme }) => theme.shades.white[20]};
    transition-property: transform, background;
    transition-duration: ${({ theme }) => theme.transitions.speeds.fast}s;
    transition-timing-function: ${({ theme }) => theme.transitions.easesCss.cubic}s;
`;
